import "core-js/modules/esnext.global-this.js";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/esnext.global-this.js";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import React4, { memo, forwardRef, useRef, useCallback, useState, useEffect } from 'react';
/*! @carvana/microfrontend-react v2.1.0 - Tue Aug 01 2023 19:40:28 GMT+0000 (Coordinated Universal Time) */

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }

  return a;
};

var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    for (var _iterator2 = _createForOfIteratorHelperLoose(__getOwnPropSymbols(source)), _step2; !(_step2 = _iterator2()).done;) {
      var prop = _step2.value;
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
  }

  return target;
};

var InternalConfig = new Proxy({
  isLoading: true,
  Components: []
}, {});

var MfeReact = function MfeReact() {
  function init(args) {
    var emitter = args.emitter,
        config = args.config,
        id = args.id,
        opts = args.opts,
        pluginManager = args.pluginManager;
    emitter && emitter.on("mfe_loaded", function () {
      InternalConfig.emitter = emitter;
      InternalConfig.id = id;
      InternalConfig.isLoading = false;
      InternalConfig.config = config;
      InternalConfig.opts = opts;
      InternalConfig.pluginManager = pluginManager;

      for (var _iterator3 = _createForOfIteratorHelperLoose(InternalConfig.Components), _step3; !(_step3 = _iterator3()).done;) {
        var ComponentToForceReload = _step3.value;
        var func = ComponentToForceReload.func;
        func && func();
      }

      InternalConfig.Components = [];
      emitter.off("mfe_loaded");
    });
    return InternalConfig;
  }

  return {
    init: init,
    name: "MfeReact"
  };
};

var isSSR = function isSSR() {
  return typeof window === "undefined" || /ServerSideRendering|SSR/i.test(window.navigator && window.navigator.userAgent);
};

var isFunction = function isFunction(fn) {
  return fn instanceof Function;
};

var GlobalModule = function GlobalModule(moduleName) {
  try {
    return globalThis[moduleName] || null;
  } catch (error) {
    return null;
  }
};

var LoadedGlobalComponent = function LoadedGlobalComponent(moduleName, componentName) {
  try {
    return (GlobalModule(moduleName) || {})[componentName];
  } catch (error) {
    return null;
  }
};

var getUuid = function getUuid(length) {
  if (length === void 0) {
    length = 8;
  }

  try {
    return _toConsumableArray(Array(length)).map(function () {
      return (~~(Math.random() * 36)).toString(36);
    }).join("") || uuidv4();
  } catch (error) {
    return uuidv4();
  }
};

var uuidv4 = function uuidv4(a) {
  if (a === void 0) {
    a = "";
  }

  return a ? ((Number(a) ^ Math.random() * 16) >> Number(a) / 4).toString(16) : (1e7 + "-" + 1e3 + "-" + 4e3 + "-" + 8e3 + "-" + 1e11).replace(/[018]/g, uuidv4);
};

var ErrorBoundary = /*#__PURE__*/function (_React4$Component) {
  _inheritsLoose(ErrorBoundary, _React4$Component);

  function ErrorBoundary(props) {
    var _this;

    _this = _React4$Component.call(this, props) || this;
    _this.state = {
      hasError: !!props.error,
      error: props.error
    };
    return _this;
  }

  ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(error) {
    return {
      hasError: !!error
    };
  };

  var _proto = ErrorBoundary.prototype;

  _proto.componentDidCatch = function componentDidCatch(error, errorInfo) {
    if (this.props.onComponentError) {
      this.props.onComponentError({
        error: error,
        id: this.props.componentId
      });
    } else {
      console.error("there was a rendering issue", {
        moduleName: this.props.moduleName,
        componentName: this.props.componentName,
        error: error,
        errorInfo: errorInfo
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        fallback = _this$props.fallback,
        debug = _this$props.debug;
    var _this$state = this.state,
        hasError = _this$state.hasError,
        error = _this$state.error;

    if (hasError) {
      return fallback ? (fallback == null ? void 0 : fallback.Component) || fallback : debug ? [error] : /*#__PURE__*/React4.createElement("div", null);
    }

    return children;
  };

  return ErrorBoundary;
}(React4.Component);

var Root = /*#__PURE__*/memo( /*#__PURE__*/forwardRef(function (props, ref) {
  var _ref = props || {},
      children = _ref.children,
      componentId = _ref.componentId,
      Component = _ref.Component,
      error = _ref.error,
      id = _ref.id;

  if (error) {
    return /*#__PURE__*/React4.createElement(ErrorBoundary, __spreadValues({}, props), children);
  }

  var doc = !isSSR() && document.getElementById(componentId);

  if (doc && !Component) {
    return /*#__PURE__*/React4.createElement("div", {
      ref: ref,
      key: componentId,
      id: componentId,
      "data-testid": componentId,
      dangerouslySetInnerHTML: {
        __html: doc.innerHTML
      }
    });
  }

  return /*#__PURE__*/React4.createElement("div", {
    ref: ref,
    key: id,
    id: componentId,
    "data-testid": componentId
  }, /*#__PURE__*/React4.createElement(ErrorBoundary, __spreadValues({}, props), children));
}));
var LoadingComponent = /*#__PURE__*/memo(function (_ref2) {
  var loading = _ref2.loading,
      SsrLegacyComponent = _ref2.SsrLegacyComponent,
      id = _ref2.id;
  if (loading !== void 0 && typeof loading === "boolean") return /*#__PURE__*/React4.createElement("div", {
    id: id
  }, "loading...");
  if (isSSR() && SsrLegacyComponent) return /*#__PURE__*/React4.createElement(SsrLegacyComponent, null);
  if (isFunction(loading)) return loading({
    id: id
  });
  return loading || null;
});
var RenderComponent = /*#__PURE__*/memo( /*#__PURE__*/forwardRef(function (props, ref) {
  var _a = props,
      children = _a.children,
      moduleComponentName = _a.moduleComponentName,
      _ = _a.Component,
      rest = __objRest(_a, ["children", "moduleComponentName", "Component"]);

  var Component = props.Component;
  Component = Component && Component.default || Component || "div";
  var scopedCssModuleName = "mfer-" + moduleComponentName + "-css-scope";
  var cssModuleScope = !isSSR() && document.getElementById(scopedCssModuleName);

  if (children && typeof children === "function") {
    return children(__spreadProps(__spreadValues({
      Component: Component
    }, rest), {
      innerRef: ref,
      style: cssModuleScope && cssModuleScope.innerHTML
    }));
  } else if (children) {
    return /*#__PURE__*/React4.createElement(React4.Fragment, null, cssModuleScope && /*#__PURE__*/React4.createElement("style", {
      id: scopedCssModuleName,
      scoped: true
    }, cssModuleScope.innerHTML), /*#__PURE__*/React4.createElement(Component, __spreadValues({
      innerRef: ref
    }, rest), children));
  }

  return /*#__PURE__*/React4.createElement(React4.Fragment, null, cssModuleScope && /*#__PURE__*/React4.createElement("style", {
    id: scopedCssModuleName,
    scoped: true
  }, cssModuleScope.innerHTML), /*#__PURE__*/React4.createElement(Component, __spreadValues({
    innerRef: ref
  }, rest)));
}));

var useWhyDidYouUpdate = function useWhyDidYouUpdate(pluginManager, name, props) {
  var previousProps = useRef();
  useEffect(function () {
    if (previousProps.current) {
      var allKeys = Object.keys(__spreadValues(__spreadValues({}, previousProps.current), props));
      var changesObj = {};
      allKeys.forEach(function (key) {
        if (previousProps.current[key] !== props[key]) {
          changesObj[key] = {
            from: previousProps.current[key],
            to: props[key]
          };
        }
      });

      if (Object.keys(changesObj).length) {
        pluginManager == null ? void 0 : pluginManager("onComponentMessage", {
          msg: "why-did-you-update",
          component: name,
          changesObj: changesObj,
          caller: "react-component"
        });
      }
    }

    previousProps.current = props;
  });
};

var AddComponentToListOfForceReRender = function AddComponentToListOfForceReRender(_ref3) {
  var id = _ref3.id,
      func = _ref3.func;

  if (!InternalConfig.Components.find(function (x) {
    return (x == null ? void 0 : x.id) === id;
  })) {
    InternalConfig.Components.push({
      id: id,
      func: func
    });
  }
};

var turnOffEmitter = function turnOffEmitter(topic, emitter) {
  if (emitter) {
    emitter.off(topic);
  }
};

var useRenderCounter = function useRenderCounter(init) {
  if (init === void 0) {
    init = 0;
  }

  var counter = useRef(init);
  return counter.current++;
};

var GetSsrModuleFromConfig = function GetSsrModuleFromConfig(files, moduleName) {
  var _a;

  if (isSSR() && files && files.length > 0) {
    try {
      var moduleFiles = (_a = files == null ? void 0 : files.find(function (x) {
        return x[0] === moduleName;
      })) == null ? void 0 : _a[1];
      var moduleFile = Array.isArray(moduleFiles) ? moduleFiles[0] : moduleFiles;
      return moduleFile == null ? void 0 : moduleFile.ssrLegacy;
    } catch (error) {
      return null;
    }
  }
};

var MfeReactComponent = /*#__PURE__*/memo( /*#__PURE__*/forwardRef(function (props, frwrdRef) {
  var _b, _c, _d, _e;

  var _a = props,
      module = _a.module,
      component = _a.component,
      fallback = _a.fallback,
      loading = _a.loading,
      children = _a.children,
      innerRef = _a.innerRef,
      onComponentLoaded = _a.onComponentLoaded,
      onComponentError = _a.onComponentError,
      onComponentTimeout = _a.onComponentTimeout,
      whyDidYouUpdate = _a.whyDidYouUpdate,
      rest = __objRest(_a, ["module", "component", "fallback", "loading", "children", "innerRef", "onComponentLoaded", "onComponentError", "onComponentTimeout", "whyDidYouUpdate"]);

  var id = useRef(getUuid());
  var rootRef = useRef();
  var moduleComponentRef = frwrdRef || innerRef || useRef();
  var renderCounter = useRenderCounter(1);
  var pluginManager = InternalConfig.pluginManager;
  var moduleComponentName = module + "-" + component;
  var componentId = rest.id || "mfer-" + moduleComponentName;
  var componentLoaded = onComponentLoaded && useCallback(onComponentLoaded, []);
  var componentError = onComponentError && useCallback(onComponentError, []);
  var componentTimeout = onComponentTimeout && useCallback(onComponentTimeout, []);
  if (whyDidYouUpdate) useWhyDidYouUpdate(pluginManager, moduleComponentName, props);
  var timer;

  var _useState = useState(false),
      hasLoaded = _useState[0],
      setHasLoaded = _useState[1];

  var _useState2 = useState(InternalConfig.isLoading),
      isMfeConfigLoading = _useState2[0];

  var _useState3 = useState(InternalConfig.error),
      error = _useState3[0],
      setError = _useState3[1];

  if ((_b = InternalConfig.config) == null ? void 0 : _b.debug) {
    pluginManager == null ? void 0 : pluginManager("onComponentMessage", {
      msg: "component rendered",
      count: renderCounter,
      module: module,
      component: component,
      caller: "react-component"
    });
  }

  var _useState4 = useState(function () {
    var _a2;

    return LoadedGlobalComponent(module, component) || GetSsrModuleFromConfig((_a2 = InternalConfig.config) == null ? void 0 : _a2.files, module);
  }),
      Component = _useState4[0],
      setComponent = _useState4[1];

  var loadComponentFromGlobalScope = function loadComponentFromGlobalScope(_ref4) {
    var module2 = _ref4.module,
        component2 = _ref4.component;
    var GlobalScopeComponent = LoadedGlobalComponent(module2, component2);

    if (GlobalScopeComponent) {
      if (!isSSR()) {
        requestAnimationFrame(function () {
          return setComponent(function () {
            return GlobalScopeComponent;
          });
        });
      } else {
        setComponent(function () {
          return GlobalScopeComponent;
        });
      }

      componentLoaded && componentLoaded({
        ref: moduleComponentRef,
        id: id.current
      });
    }

    return !!GlobalScopeComponent;
  };

  useEffect(function () {
    if (!hasLoaded && isMfeConfigLoading && !Component) {
      AddComponentToListOfForceReRender({
        id: id.current,
        func: function func() {
          return setHasLoaded(function (x) {
            return !x;
          });
        }
      });
    }
  }, []);
  useEffect(function () {
    if (loadComponentFromGlobalScope({
      module: module,
      component: component
    })) return;

    if (InternalConfig.emitter) {
      InternalConfig.emitter.on(moduleComponentName, function (props2) {
        var _ref5 = props2 || {},
            componentName = _ref5.componentName,
            moduleName = _ref5.moduleName;

        if (component === componentName && module === moduleName) {
          if (timer) clearTimeout(timer);
          loadComponentFromGlobalScope({
            module: module,
            component: component
          });
          turnOffEmitter(moduleComponentName, InternalConfig.emitter);
        }
      });
    }

    return function () {
      turnOffEmitter(moduleComponentName, InternalConfig.emitter);
    };
  }, [(_c = InternalConfig) == null ? void 0 : _c.isLoading]);
  useEffect(function () {
    if (!Component && fallback && fallback.Component && fallback.timeout && fallback.timeout > 0) {
      timer = setTimeout(function () {
        if (!Component) {
          componentTimeout && componentTimeout({
            id: id.current
          });
          setError(new Error("timeout reached"));
        }
      }, fallback.timeout);
    }

    return function () {
      if (timer) clearTimeout(timer);
    };
  }, [Component]);
  return /*#__PURE__*/React4.createElement(Root, {
    ref: rootRef,
    id: id.current,
    componentId: componentId,
    moduleName: module,
    componentName: component,
    fallback: fallback,
    Component: Component,
    debug: ((_d = InternalConfig.config) == null ? void 0 : _d.debug) || false,
    error: error,
    onComponentError: componentError
  }, Component ? /*#__PURE__*/React4.createElement(RenderComponent, __spreadProps(__spreadValues(__spreadValues({}, (_e = InternalConfig.config) == null ? void 0 : _e.shared), rest), {
    Component: Component,
    id: id.current,
    componentId: componentId,
    children: children,
    ref: moduleComponentRef,
    moduleComponentName: moduleComponentName
  })) : /*#__PURE__*/React4.createElement(LoadingComponent, {
    id: id.current,
    loading: loading
  }));
}));
export { MfeReact, MfeReactComponent };